<template lang="html">

  <div class="login-view column-center" :style="`background:url(${getBackground}) center/cover no-repeat`">

    <form @submit.prevent="validation" :style="ownstyles.popup" v-if="!!!getOwnlogin || getGodmodeStatus">

      <div class="contenedor-logo">
        <img :src="(!!getBrand.logoLogin) ? getBrand.logoLogin : getBrand.logocolor">
      </div>

      <h2 class="title-dato" :style="getStyles.colorbasic">Iniciar sesión</h2>

      <div class="contenedor-input">
        <label for="usuario">Email</label>
        <input type="text" v-model="data.eUsuario" id="usuario" :hasContent="!!data.eUsuario" :style="getStyles.input_black">
      </div>

      <div class="contenedor-input" @mouseleave="view.revealPass = false">
        <label for="password">Contraseña</label>
        <input :type="view.revealPass ? 'text' : 'password'" v-model="data.ePassword" id="password" :hasContent="!!data.ePassword" :style="getStyles.input_black">
        <reveal class="revealPass" :isReveal="view.revealPass" :basic="true"></reveal>
        <i @click="view.revealPass = !view.revealPass" class="revealPass"></i>
        <a class="link lostPass" @click="view.showRecuperar = true" :style="getStyles.colorTextBlack">He olvidado mi contraseña</a>
      </div>

      <div class="column-center">
        <button class="btn load-blue" :style="getStyles.solidPrimary" :disabled="!canSend" :loading="view.loading">Acceder</button>
      </div>
    </form>

    <div class="contenedor-login-terceros"  :style="ownstyles.popup" v-if="!!getOwnlogin && !!!getGodmodeStatus">


      <div class="contenedor-logo">
        <img :src="getLogoColor">
      </div>

      <h2 class="title-dato" :style="getStyles.colorbasic">Iniciar sesión</h2>

      <div class="texto">
        <p v-html="getOwnlogin.texto"></p>
      </div>

      <a class="btn" @click="validarRecuperarEmail" :style="getStyles.solidPrimary" :href="getServer+'/AuthUniversidades/solicitudAcceso.aspx?portal=tutor'">Acceder</a>

      
    </div>

    <div class="cover-popup -recuperar row-center" v-if="view.showRecuperar">

      <div class="popup"  :style="ownstyles.popup">

        <a class="cerrar -small" @click="view.showRecuperar = false">✕</a>

        <div class="contenedor-input">
          <label for="">Introduce tu email</label>
          <input type="text" :style="getStyles.input_black" v-model="emailRecuperar">
          <span class="error" v-if="showerror">El email está mal formado</span>
        </div>

        <a class="btn" @click="validarRecuperarEmail" :style="getStyles.solidPrimary">Recuperar mi contraseña</a>

      </div>

    </div>

  </div>




</template>

<script lang="js">


  import {mapActions, mapGetters} from 'vuex';

  import router from '@/router'

  import reveal from '@/components/parts/icons/reveal'

  export default  {
    name: 'login',
    props: [],
    mounted(){
      if(location.search.includes('idPractica')){
        window.sessionStorage.setItem('idPractica',location.search.split('=')[1]);
      }
    },
    data() {
      return {
       data : {
        eUsuario : '',
        ePassword : '',
        eAmbito : 'PrivadoTutor'
      },
      view : {
        revealPass : false,
        showRecuperar : false,
        loading : false
      },
      emailRecuperar: '',
      showerror : false
    }
  },
  components :{
    'reveal' : reveal
  },
  methods: {
    ...mapActions(['login','recuerdoPass']),
    validation : function(){
      if(this.canSend){
        this.view.loading = true;
        this.login(this.data).then(response => {
          this.view.loading = false;
        }).catch(e =>{
          this.view.loading = false;
        });
      }
    },
    validarRecuperarEmail(){
      if(this.emailRecuperar.includes('@')){
        this.recuerdoPass(this.emailRecuperar).then( r => {
          console.log(r);
          if(r){
            this.emailRecuperar = '';
            this.view.showRecuperar = false;
          }
        });
      }else{
        this.showerror = true;
      }
    }
  },
  computed : {
    ...mapGetters([,'getStyles','getLogoColor', 'basicColors','getBackground','getOwnlogin','getServer','getBrand', 'getGodmodeStatus']),
    ownstyles : function() {
      return {
        popup : {
          background : this.basicColors.white
        }
      }
    },
    canSend : function(){
      var can = (!!this.data.eUsuario && !!this.data.ePassword);
      return can;
    }
  }
}
</script>

<style scoped lang="scss">

  .login-view{
    width: 100%;
    height: 100vh;
  }

  form{
    max-width: 600px;
    padding: 50px;
    width: 100%;
  }

  .logo{
    margin-bottom: 40px;
  }

  .title-dato{
    margin-bottom: 40px;
    text-align: center;
  }

  .contenedor-botones{
    width: 100%;
  }

  .btn{
    margin-top: 20px;
  }

  .contenedor-login-terceros{
    .btn{margin-top: 30px;}
  }
  
  .contenedor-logo{
    max-width: 250px;
    width: 100%;
    height: 60px;
    display: inline-block;
    margin-bottom: 30px;
  }

  .contenedor-logo img{
    display: inline-block;
    max-width: 100%;
    max-height: 100%;
  }

  .contenedor-input.type-checkbox{
    margin-top: 20px;
  }

  .revealPass{
    border: none;
    outline: none;
    display: inline-block;
    position: absolute;
    right: 0;
    bottom: 45px;
    z-index: 2;
    cursor: pointer;
    width: 30px;
    height: 30px;
    line-height: 30px;
  }


  .lostPass{
    width: 100%;
    line-height: 20px;
    text-decoration: underline;
    color: currentColor;
    text-align: left;
    font-size: 12px;
    font-weight: 400;
    cursor: pointer;
    display: inline-block;
    width: 100%;
  }

  @media screen and (max-height: 700px){

    .title-dato{
      margin-bottom: 20px;
    }

    .contenedor-botones{
      margin-top: 20px;
    }

  }


  @media screen and (max-width: 768px){

    .login-view{
      padding: 10px;
    }
    form{
      padding: 20px;
      max-width: 400px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/views/login.vue